import PageHeader from "@/components/PageHeader";
import Team from "@/components/Team";
import Contact from "@/components/Contact";

export default function CasaPage() {
  return (
    <>
      <PageHeader
        overline="Besuch & Kontakt"
        title="Casa Markus"
        accent="Zürcher."
        subtitle="Hauptstrasse 74, 4102 Binningen — bei der Hohle Gasse. Tram Nr. 2 bis Binningen Kronenplatz, dann 6 Minuten zu Fuss. Geöffnet Dienstag bis Samstag."
      />
      <Team />
      <Contact />
    </>
  );
}
